var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"checkbox-accordion",class:{ 'has-error': _vm.error }},[_vm._t("default"),(_vm.error)?_c('p',{staticClass:"error-text"},[_vm._v("* "+_vm._s(_vm.error))]):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }